import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M1.54349 9C-0.514496 11.058 -0.514498 14.3985 1.54349 16.4565C3.60148 18.5145 6.94198 18.5145 8.99997 16.4565L13.4739 11.9826C14.7042 10.7523 14.7042 8.73902 13.4739 7.5087C12.2435 6.27838 10.2303 6.27838 8.99997 7.5087L4.52608 11.9826C4.11598 12.3927 4.11597 13.0638 4.52608 13.4739C4.93619 13.884 5.60727 13.884 6.01738 13.4739L10.4913 9C10.9014 8.58989 11.5725 8.58989 11.9826 9C12.3927 9.41011 12.3927 10.0812 11.9826 10.4913L7.50867 14.9652C6.27835 16.1955 4.2651 16.1955 3.03478 14.9652C1.80447 13.7349 1.80447 11.7216 3.03479 10.4913L10.4913 3.0348C11.7216 1.80447 13.7348 1.80447 14.9652 3.0348C15.7108 3.78045 16.0389 4.85419 15.8227 5.89064C15.7108 6.46479 16.0762 7.02403 16.6503 7.13588C17.2245 7.24773 17.7837 6.88236 17.8956 6.30821C18.246 4.57084 17.7017 2.78873 16.4564 1.5435C14.3985 -0.514499 11.058 -0.514499 8.99997 1.5435L1.54349 9Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}